import { toTitleCase } from "@/components/common/validation/Validators";
import { useEffect } from "react";
import { connect } from "react-redux";
import Logo from "./assets/bamboo-icon.svg";
import { Actions as BAMBOO_ACTIONS } from "./store/bambooActions";

const BambooPushChanges = ({
	agreement,
	disabled,
	pushChanges,
	resyncingEmployee,
	thirdPartyId,
	thirdPartyList,
	getBambooEmployees,
	section,
	loading,
	bamboo,
}) => {
	useEffect(() => {
		if (typeof thirdPartyList === "undefined") getBambooEmployees();
	}, [thirdPartyList, bamboo]);

	if (!thirdPartyId || ["desynced", "ignored"].includes(thirdPartyId)) return null;
	return (
		<button
			disabled={disabled || resyncingEmployee}
			className="btn btn-default pull-right"
			type="button"
			style={{ marginRight: 10 }}
			onClick={() => pushChanges(agreement)}
		>
			<img
				src={Logo}
				style={{ height: "1.5em", float: "left" }}
			/>
			<div style={{ float: "left", marginLeft: 5 }}>
				{loading ? "Loading" : "Update"} {toTitleCase(section)}
			</div>
		</button>
	);
};

const mapStateToProps = (state, ownProps) => {
	const agreement = state.employee.agreementInfo?.id;
	const agreementInfo = ownProps.agreementInfo ? ownProps.agreementInfo : state.employee.agreementInfo;

	const resyncingEmployee = state.integration?.hris?.bambooHr?.resyncingEmployee;
	const thirdPartyId =
		state.employee?.bambooHrLink ||
		state?.integration?.hris?.bambooHr?.links?.find?.((e) => e?.agreement == agreementInfo?.id)?.link;
	const thirdPartyList = state.integration?.hris?.bambooHr?.employees?.map?.((e) => ({
		label: `${e.firstName} ${e.lastName}`,
		value: e.id,
	}));

	return {
		thirdPartyList,
		bamboo: !!state.integration?.hris?.bambooHr,
		agreement,
		resyncingEmployee,
		loading: state.integration?.hris?.bambooHr?.loadingPushChanges,
		thirdPartyId,
	};
};

const mapDispatchToProps = (dispatch, { section }) => ({
	getBambooEmployees: () => dispatch(BAMBOO_ACTIONS.getBambooEmployees()),
	pushChanges: (agreement) => dispatch(BAMBOO_ACTIONS.pushChanges({ agreement, section })),
});

export default connect(mapStateToProps, mapDispatchToProps)(BambooPushChanges);
